module.exports = __webpack_public_path__ + "./Daniel_7ed55834451d2645640d9d09f0c6a997.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2022/Daniel.jpg
// module id = 548
// module chunks = 0